import { EntityType } from '@frontend/common';
import { Spinner } from '@frontend/components/common';
import { Form } from '@frontend/components/forms';
import { EnumSelectListV2 } from '@frontend/components/select';
import { OrderClient } from '@frontend/order/api';
import { Order, UpdateOrder } from '@frontend/order/types';
import { useMemo } from 'react';

import { useOrderUpdate } from './order-update.controller';

const ID = 'order-update';
export const OrderUpdate = () => {
    const viewProps = useOrderUpdate();

    const enumOverwrite = useMemo(() => new Map<keyof UpdateOrder, keyof typeof EnumSelectListV2>([['state', 'order_status']]), []);

    return (
        <div id={ID}>
            {viewProps.order === null ? (
                <Spinner />
            ) : (
                <Form<Order, UpdateOrder>
                    id={ID}
                    useStaticId
                    object={viewProps.order}
                    type={EntityType.ORDER}
                    dispatch={viewProps.dispatch}
                    value={viewProps.order}
                    show={['number', 'state', 'user_id', 'quantity', 'spot_id']}
                    onCancel={viewProps.onCancel}
                    onSubmit={(v) => OrderClient.patchOrder(viewProps.order!.account_id, viewProps.order!.id, v)}
                    onSubmitSuccess={viewProps.onSubmitSuccess}
                    enumOverwrite={enumOverwrite}
                />
            )}
        </div>
    );
};
